import React from 'react';
import haWrapper from '../../utils/haWrapper';
import {sendCustomAnalytics} from '../../utils/loadTimeAnalyticsWrapper';

const MEASURE_NAME = 'search.bar.loaded';

const withSearchBarLoadTime = (WrappedComponent) => {
    let namedWrappedComponent = class extends React.Component {
        constructor(props) {
            super(props);
        }

        componentDidMount() {
            const {userTiming} = haWrapper;
            const alreadyMeasured =
                userTiming.getEntriesByName(MEASURE_NAME, 'measure').length > 0;

            if (!alreadyMeasured) {
                userTiming.markAndMeasureAndSend(MEASURE_NAME);
                sendCustomAnalytics(MEASURE_NAME, 'mark', (analytics) => ({
                    searchBarRendered: Math.ceil(analytics.startTime)
                }));
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    /* istanbul ignore next */
    namedWrappedComponent.displayName = `withSearchBarRendered(${WrappedComponent.displayName ||
        WrappedComponent.name ||
        'Component'})`;
    return namedWrappedComponent;
};
export default withSearchBarLoadTime;
